<template>
    <div>
        <div id="starthere"></div>
        <!-- PRICING -->
        <div class="pricing-section">
            <div class="pricing-section-left-bg-graphics">
                <img src="assets/images/pricing-section-left-bg.png">
            </div>
            <div class="pricing-section-right-bg-graphics">
                <img src="assets/images/pricing-section-right-bg.png">
            </div>
            <div class="container pricing-container">
                <div class="pricing-title">
                    <h2>Start hier!</h2>
                    <p>Start vandaag gratis met Family Portal App!</p>
                </div>
                <get-started v-if="! showFormFamily && ! showFormCareFacility && ! showStartApp && ! showStartServer" @start-care-facility="formCareFacility" @start-family="formFamily"></get-started>
                <form-family v-if="showFormFamily" @close-form="closeForm"></form-family>
                <form-care-facility v-if="showFormCareFacility" @close-form="closeForm"></form-care-facility>
                <thank-you v-if="showStartApp || showStartServer"></thank-you>
                <!-- <start-app v-if="showStartApp"></start-app>
                <start-server v-if="showStartServer"></start-server> -->
            </div>
        </div>
        <!-- SECTION LABEL -->
        <div id="howto"></div>
        <div class="pricing-section">
            <div class="container pricing-container">
                <div class="pricing-title">
                    <h2>Hoe werkt het?</h2>
                    <p>Family Portal is een Progressive Web App (PWA) en werkt op Android & iOS.</p>
                    <p>U kan de app installeren via de Google Play Store of de iOS App Store.</p>
                    <p>De app werkt ook gewoon in de browser (<a href="https://app.familyportal.be">https://app.familyportal.be</a>) als u liever geen bijkomende apps op uw smartphone wenst.</p>
                </div>
                <!-- PRICE PLANS -->
                <div class="row" style="margin-top: 15px;">

                    <div class="col-lg-6 col-xs-12">
                        <img src="../assets/images/android-store.png" width="250px" />
                    </div>
                    
                    <div class="col-lg-6 col-xs-12">
                        <img src="../assets/images/app-store.png" width="250px" />
                    </div>
                </div>
            </div>
        </div>	
    </div>
</template>

<script>
import GetStarted from './GetStarted'
import FormFamily from './FormFamily'
import StartApp from './StartApp'
import StartServer from './StartServer'
import ThankYou from './ThankYou'
import FormCareFacility from './FormCareFacility'

export default {
    data() {
        return {
            showFormFamily: false,
            showFormCareFacility: false,
            showStartApp: false,
            showStartServer: false,
            careFacility: {
                userLastName: '',
                userFirstName: '',
                userEmail: '',
                userPassword: '',
                userSexe: '',
                facilityName: '',
                facilityType: ''
            }
        }
    },

    components: {
        GetStarted, FormFamily, FormCareFacility, StartApp, StartServer, ThankYou
    },

    methods: {

        closeForm(userInformation) {
            if(userInformation !== undefined) {
                // show the go to app component
                // this is a final stage
                if(this.showFormFamily == true)
                {
                    this.showFormFamily = false
                    this.showStartApp = true
                }
                if(this.showFormCareFacility == true)
                {
                    this.showFormCareFacility = false
                    this.showStartServer = true
                }
            } else {
                this.showFormFamily = false
                this.showFormCareFacility = false
            }
        },

        formFamily() {
            this.showFormFamily = true
        },

        formCareFacility() {
            this.showFormCareFacility = true
        }

    }
}
</script>

<style>

</style>